<app-layout-page>
  <app-layout-header>
  </app-layout-header>
  <app-layout-content>
    <div class="large-icon-with-inset" aria-hidden="true">
      <img src="/assets/image/graphic/phone-camera.svg" class="large-icon">
      <mat-icon class="inset-icon color-error">error</mat-icon>
    </div>
    <h2 trans="face_check.orientation_error.title"></h2>
  </app-layout-content>
  <app-layout-buttons>
    @if (showBrowserProblemLink) {
      <app-browser-problem-link></app-browser-problem-link>
    }
  </app-layout-buttons>
</app-layout-page>
